// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ee3U","col":"styles_col__2yBZV"};